export default __webpack_public_path__ + "images/service-now.svg";